import { Box, Checkbox, Icon, Typography } from "@mui/material";
import { FolderDto } from "../../../api/psc";

// updated
export default function SelectFolderItem(props: {
    folder: FolderDto;
    onToggle: (FolderDto) => void;
    checked: boolean;
}) {
    return (
        <Box
            sx={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 1,
            }}
            onClick={() => props.onToggle(props.folder)}
        >
            <Icon sx={{ color: `#${props.folder.color}` }}>circle</Icon>
            <Typography sx={{ flexGrow: 1 }}>{props.folder.title}</Typography>
            <Checkbox checked={props.checked} />
        </Box>
    );
}
